module.exports = __webpack_public_path__ + "static/media/СЗФО_2003.7c8e5ebd.png";